export default function NotreEntreprise() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="max-w-4xl">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-6 md:mb-8">
            Notre entreprise
          </h2>
          <div className="space-y-5 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              DF PRO est une entreprise locale spécialisée dans la réparation de fenêtres, basée à Strasbourg dans le Bas-Rhin. Notre équipe est composée de techniciens formés spécifiquement à la menuiserie et à la quincaillerie de fenêtre, avec une expertise reconnue sur les mécanismes oscillo-battants, les crémones, les poignées, les gonds et les paumelles. Nous intervenons à domicile chez nos clients dans tout le Bas-Rhin, avec un atelier situé au 82 rue de Heidenberg à Strasbourg.
            </p>
            <p>
              Notre approche est simple et efficace : au lieu de vous proposer le remplacement coûteux d'une fenêtre entière, nous réparons le mécanisme défectueux sur place. Cette méthode permet de réparer dans plus de 90% des cas, à un coût bien inférieur à un remplacement complet. Nos techniciens sont équipés de pièces neuves pour toutes les marques de quincaillerie et interviennent avec rapidité et professionnalisme.
            </p>
            <p>
              Basée à Strasbourg, notre entreprise intervient dans toute l'agglomération et les communes du Bas-Rhin : Haguenau, Bischheim, Schiltigheim, Illkirch-Graffenstaden, Bischwiller, Obernai, Hœnheim et bien d'autres. Notre atelier est ouvert du lundi au samedi de 8h à 18h, et nous sommes disponibles par téléphone au 03 74 47 10 36.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}